"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableModificators = void 0;
const react_1 = require("react");
const useTableModificators = (highlightAllotmentInvoiceId) => (0, react_1.useMemo)(() => ({
    row: (row) => {
        const { id } = row.original;
        const getHighlightModificator = () => {
            if (highlightAllotmentInvoiceId !== undefined && highlightAllotmentInvoiceId === id)
                return 'highlight';
            return undefined;
        };
        return [
            getHighlightModificator(),
        ];
    },
    column: (column) => ([
        column.disableShowForDevice ? 'device-hidden' : undefined,
        column.isCheckboxColumn ? 'checkbox-cell' : undefined,
        column.isAvailableSeatsColumn ? 'available-seats-cell' : undefined,
    ]),
}), [highlightAllotmentInvoiceId]);
exports.useTableModificators = useTableModificators;
//# sourceMappingURL=modificators.js.map